import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, n = /* @__PURE__ */ o("path", { d: "M13.585 42.826H5.76v-25.15h7.824v25.15Zm-3.91-28.587A4.53 4.53 0 0 1 5.14 9.706a4.533 4.533 0 1 1 4.535 4.533ZM42.86 42.826h-7.815v-12.23c0-2.916-.05-6.669-4.062-6.669-4.067 0-4.688 3.18-4.688 6.46v12.439h-7.807v-25.15h7.493v3.438h.107c1.042-1.978 3.592-4.062 7.395-4.062 7.914 0 9.377 5.207 9.377 11.98v13.794Z" }, null, -1), r = [
  n
];
function h(s, v) {
  return e(), t("svg", c, r);
}
const l = { render: h };
export {
  l as default,
  h as render
};
//# sourceMappingURL=linkedin.svg.mjs.map
